// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1WOcg","title":"Header_title__KtNCE","left":"Header_left__1G-sh","clinicName":"Header_clinicName__3H5yq"};